import React, { Component } from 'react';
import {Form, Control, Errors, Fieldset} from "react-redux-form";
import { isRequired } from "../field_validations";
import _ from "lodash";
import {required} from "../field_validations";
import {toInt} from "../parsers";

class SurveysEditForm extends Component {
	render(){
		const { surveys, status } = this.props;
		let surveyType = _.find(surveys.types.list,{id: _.toNumber(surveys.edit.survey_type_id)})
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					{this.state.modalShow ? <QuestionModal active={this.state.modalShow} closeModal={() => this._toggleModal()} {...this.props}/>:''}
					<Form model="surveys.edit" onSubmit={(values) => {this._handleSubmit(values)}} onSubmitFailed={(error) => {console.log('error: ', error); this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}}>
						<div className="hero is-light">
							<div className="hero-body">
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="name" className="label">Nombre de Encuesta <span className="small has-text-danger">*</span></label>
										<Control.text model=".name" id="name" className="input" errors={{isRequired}} validateOn="change"/>
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="survey_type_id" className="label">Tipo de Encuesta <span className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select model=".survey_type_id" id="survey_type_id" ref="survey_type_id" errors={{required}} validateOn="change">
												<option value="">-- Tipo --</option>
												{_.map(surveys.types.list,(option, k) => {
													return <option value={option.id} key={k}>{option.name}</option>
												})}
											</Control.select>
										</div>
										<Errors model=".survey_type_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar el tipo de Encuesta '}} />
									</div>

									<div className="control">
										<label htmlFor="status_id" className="label">Estatus <span className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select model=".status_id" id="status_id" className="select" errors={{required}} validateOn="change">
												<option value="" defaultValue>--- Estatus ---</option>
												{_.map(status.data,(stat, k) => {
													return <option value={stat.id} key={k}>{stat.name}</option>
												})}
											</Control.select>
										</div>
										<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
									</div>
								</div>
							</div>
						</div>

						<hr/>

						<div className="hero is-light">
							<div className="hero-body">
								<div className="hero-subsection">
									<div className="field is-grouped">
										<div className="control is-expanded">
											<label htmlFor="question" className="label">{this.state.type === 'group' ? 'Nombre de grupo':'Pregunta'}<span className="small has-text-danger">*</span></label>
											<textarea name="question" ref="question" id="question" rows={2} className="textarea" placeholder={this.state.type === 'group' ? 'Nombre de grupo':'Pregunta'} value={this.state.question} onChange={this._changeData}/>
										</div>
									</div>

									<div className="field is-grouped">
										<div className="control">
											<label htmlFor="type" className="label">Tipo <span className="small has-text-danger">*</span></label>
											<div className="select">
												<select name="type" id="type" ref="type" value={this.state.type} onChange={this._changeData}>
													<option defaultValue disabled>-- Tipo --</option>
													<option value="question">Pregunta</option>
													<option value="group">Grupo</option>
												</select>
											</div>
										</div>

										{this.state.type === 'question' ?
											<div className="control">
												<label htmlFor="typeQuestion" className="label">Tipo de pregunta <span className="small has-text-danger">*</span></label>
												<div className="select">
													<select name="typeQuestion" ref="typeQuestion" id="typeQuestion" value={this.state.typeQuestion} onChange={this._changeData}>
														<option value="">-- Tipo de pregunta --</option>
														{surveyType && surveyType.slug === 'validacion-de-comisiones' ?
														<option value="sum">Suma</option>:''}
														{surveyType && surveyType.slug === 'encuesta-satisfaccion-informes' ?
															<option value="rating">Calificación (1 al 5)</option>:''}
														<option value="text">Area de texto</option>
													</select>
												</div>
											</div>:''}
									</div>

									<div className="field is-grouped is-grouped-right">
										<div className="control">
											<button type="button" className="button is-primary" onClick={() => {this._addQuestion()} } disabled={this._validAdd()}>Agregar</button>
										</div>
									</div>
								</div>

								<hr/>

								{!_.isEmpty(surveys.edit.children_questions) ?
									<div className="hero-subsection">
										<br />
										<label className="title is-5">Listado de preguntas</label>
										<br /><br/>
										<table className="table is-fullwidth is-bordered">
											<thead>
											<tr>
												<th>#</th>
												<th>Pregunta/Grupo</th>
												<th>Tipo</th>
												<th>Acciones</th>
											</tr>
											</thead>
											<tbody>
											{_.map(surveys.edit.children_questions,(row, k) => {
												return [
													<tr key={k}>
														<td>
															<strong>{k+1}</strong>
														</td>
														<td>{row.name}</td>
														<td>{this._getType(row.type)}</td>
														<td>
															<div className="field is-grouped">
																<div className="control">
																	<button type="button" className="button is-info" onClick={() => this._editQuestion(k, undefined, row)}><i className="fa fa-edit" /></button>
																</div>
																<div className="control">
																	<button type="button" onClick={() => this._removeQuestion(k)} className="button is-danger"><i className="fa fa-trash" /></button>
																</div>
															</div>
														</td>
													</tr>,
													!_.isEmpty(row.children_questions) ?
														<tr key={`questions-${k}`}>
															<td colSpan={4}>
																<table className="table is-fullwidth project-activity-table">
																	<thead>
																	<tr>
																		<th>#</th>
																		<th>PREGUNTA</th>
																		<th>TIPO</th>
																		<th>ACCIONES</th>
																	</tr>
																	</thead>
																	<tbody>
																	{_.map(row.children_questions, (children, q) => {
																		return (
																			<tr key={q}>
																				<td className="has-text-centered" style={{width:'10%'}}>
																					{q+1}
																				</td>
																				<td>{children.name}</td>
																				<td>{this._getType(children.type)}</td>
																				<td>
																					<div className="field is-grouped">
																						<div className="control">
																							<button type="button" className="button is-info" onClick={() => this._editQuestion(k, q, children)}><i className="fa fa-edit" /></button>
																						</div>
																						<div className="control">
																							<button type="button" onClick={() => this._removeQuestion(k,q)} className="button is-danger"><i className="fa fa-trash" /></button>
																						</div>
																					</div>
																				</td>
																			</tr>
																		)
																	})}
																	</tbody>
																</table>
															</td>
														</tr>:null
												]
											})}
											</tbody>
										</table>
									</div>
									:''}
							</div>
						</div>

						<br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" model="surveys" className="button is-large" onClick={() => this.props.history.push('/encuestas')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="surveys.edit" className="button is-primary is-large" type="submit" >
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			modalShow: false,
			type: 'question',
			question: '',
			typeQuestion: '',
			questionIndex: 0
		}

		this._changeData = this._changeData.bind(this)
	}

	_changeData(event){
		this.setState({
			[event.target.name]: event.target.value
		})
	}

	_validAdd(){
		let { type, typeQuestion, question } = this.state;
		let response = true;

		if(type && question){
			if(type === 'group'){
				response = false;
			}else if(typeQuestion){
				response = false;
			}
		}

		return response;
	}

	_addQuestion(){
		let { type, typeQuestion, question } = this.state;

		if(type && question){
			if(type === 'group'){
				this.props.add('surveys.edit.children_questions',{
					name: question,
					type: type,
					children_questions: []
				})
				this.setState({
					type: 'question',
					question: '',
					typeQuestion: ''
				})
			}else if(typeQuestion){
				this.props.add('surveys.edit.children_questions',{
					name: question,
					type: typeQuestion,
					options: []
				})
				this.setState({
					type: 'question',
					question: '',
					typeQuestion: ''
				})
			}
		}
	}

	_removeQuestion(indexQuestion, IndexChildren){
		if(_.isNumber(IndexChildren)){
			this.props.remove(`surveys.edit.children_questions[${indexQuestion}].children_questions`,IndexChildren);
		}else {
			this.props.remove(`surveys.edit.children_questions`,indexQuestion);
		}
	}

	_editQuestion(indexFhather, indexChildren, data){

		this.props.change(`surveys.edit.question`,{
			...data,
			indexFhather: indexFhather,
			indexChildren: indexChildren
		})

		this.setState({
			modalShow: true
		})
	}

	_toggleModal() {
		this.setState({modalShow: !this.state.modalShow});
	}

	_getType(type){
		switch (type){
			case 'group':
				return 'Grupo'
			case 'number':
				return 'Número'
			case 'sum':
				return 'Suma'
			case 'average':
				return 'Promedio'
			case 'percentage':
				return 'Porcentaje'
			case 'interval':
				return 'Intervalo'
			case 'rating':
				return 'Calificación (1 al 5)'
			case 'input':
				return 'Texto Simple'
			case 'text':
				return 'Área de Texto'
			case 'boolean':
				return 'Verdadero/Falso'
			case 'multiple':
				return 'Opción multiple'
			default:
				return '';
		}
	}

	_handleSubmit(values) {
		this.props.surveySave(values)
	}
}

class QuestionModal extends Component {
	render() {
		const { surveys } = this.props
		const { question } = surveys.edit;
		let surveyType = _.find(surveys.types.list,{id: _.toNumber(surveys.edit.survey_type_id)})
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" />
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>{`Edicion de ${question.type === 'group' ? 'grupo':'pregunta'}`}</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							<Fieldset model={`surveys.edit.question`}>
								<div className="field">
									<div className="control">
										<label htmlFor="name" className="label">{question.type === 'group' ? 'Grupo':'Pregunta'} <span className="small has-text-danger">*</span></label>
										<Control.textarea model=".name" id="name" rows={2} className="textarea"/>
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="type" className="label">Tipo de Pregunta <span className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select model=".type" id="type" changeAction={(model,value) => this._changeType(model,value)}>
												<option defaultValue disabled>-- Tipo --</option>
												{!_.isNumber(question.indexChildren) ?
													<option value="group">Grupo</option>:null}
												{surveyType && surveyType.slug === 'validacion-de-comisiones' ?
													<option value="sum">Suma</option>:''}
												{surveyType && surveyType.slug === 'encuesta-satisfaccion-informes' ?
													<option value="rating">Calificación (1 al 5)</option>:''}
												<option value="text">Area de texto</option>
											</Control.select>
										</div>
										<Errors model=".type" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Seleccionar el tipo'}} />
									</div>

									<div className="control">
										<label htmlFor="position" className="label">Posición</label>
										<Control.text model=".position" id="position" type="number" min={1} step={1} className="input" changeAction={(m,v) => this._changePosition(m,v)}/>
									</div>
								</div>

								{question.type === 'sum' ?
								<div className="field">
									<div className="control">
										<label className="label">Opción</label>
										<div className="field has-addons">
											<div className="control">
												<input name="option_number" ref="option_number" id="option_number" parser={ toInt } type="number" min={1} step={1} className="input" placeholder="valor"/>
											</div>

											<div className="control is-expanded">
												<input name="option_text" ref="option_text" id="option_text" className="input" placeholder="Texto"/>
											</div>

											<div className="control">
												<button type="button" className="button is-info" onClick={() => this._addOption()} >Agregar</button>
											</div>
										</div>
									</div>
								</div>:''}

								{question.type === 'group' ?
								<div className="field">
									<div className="control">
										<label className="label">Pregunta</label>
										<div className="field has-addons">
											<div className="control is-expanded">
												<input name="question" ref="question" id="question" type="text" className="input" placeholder="Pregunta" value={this.state.question} onChange={this._changeData}/>
											</div>

											<div className="control">
												<div className="select">
													<select name="typeQuestion" ref="typeQuestion" id="typeQuestion" value={this.state.typeQuestion} onChange={this._changeData}>
														<option value="">-- Tipo --</option>
														{surveyType && surveyType.slug === 'validacion-de-comisiones' ?
															<option value="sum">Suma</option>:''}
														{surveyType && surveyType.slug === 'encuesta-satisfaccion-informes' ?
															<option value="rating">Calificación (1 al 5)</option>:''}
														<option value="text">Area de texto</option>
													</select>
												</div>
											</div>

											<div className="control">
												<button type="button" className="button is-info" onClick={() => {this._addQuestion()} } disabled={this._validAddQuestion()}>Agregar</button>
											</div>
										</div>
									</div>
								</div>:''}

								{!_.isEmpty(question.options) ?
									<table className="inm-table">
										<thead>
										<tr>
											<th>ID</th>
											<th>VALOR</th>
											<th>TEXTO</th>
											<th>ACCIONES</th>
										</tr>
										</thead>
										<tbody>
										{_.map(question.options,(opc,k) => {
											return (
												<tr key={k}>
													<td>{k+1}</td>
													<td >{opc.option_number}</td>
													<td style={{width:'60%'}}>{opc.option_text}</td>
													<td>
														<div className="field is-grouped">
															<div className="control">
																<button type="button" className="button is-danger" onClick={() => this._removeOption(k)}><i className="fa fa-trash" /></button>
															</div>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
									:''}

								{!_.isEmpty(question.children_questions) ?
									<table className="inm-table">
										<thead>
										<tr>
											<th>#</th>
											<th>PREGUNTA</th>
											<th>TIPO</th>
											<th>ACCIONES</th>
										</tr>
										</thead>
										<tbody>
										{_.map(question.children_questions,(children,q) => {
											return (
												<tr key={q}>
													<td className="goal-cell" style={{width:'10%'}}>
														<strong>{q+1}</strong>
													</td>
													<td><strong>{children.name}</strong></td>
													<td><strong>{this._getType(children.type)}</strong></td>
													<td>
														<div className="field is-grouped">
															<div className="control">
																<button type="button" onClick={() => this._removeQuestion(q)} className="button is-danger"><i className="fa fa-trash" /></button>
															</div>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
									:''}
								<br/>
								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button model="surveys" className="button is-info" onClick={this.props.closeModal}>
											Cerrar
										</button>
									</div>

									<div className="control">
										<button type="button" className="button is-success" onClick={() => this._saveQuestion()}>Guardar</button>
									</div>
								</div>

								<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
							</Fieldset>
						</div>
					</div>
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			question: '',
			typeQuestion: ''
		}

		this._changeData = this._changeData.bind(this)
	}

	_changeData(event){
		this.setState({
			[event.target.name]: event.target.value
		})
	}

	_saveQuestion(){
		let {question} = this.props.surveys.edit;

		if(question.name && question.type){
			if(_.isNumber(question.indexChildren)){
				this.props.change(`surveys.edit.children_questions[${question.indexFhather}].children_questions[${question.indexChildren}]`,{
					...question
				})
			}else {
				this.props.change(`surveys.edit.children_questions[${question.indexFhather}]`,{
					...question
				})
			}
			this.props.closeModal();
		}else {
			alert('Hay errores en el formulario');
		}
	}

	_changeType(model,value){
		this.props.change(model,value);
		this.props.change('surveys.edit.question.options', []);
		this.props.change('surveys.edit.question.children_questions', []);
	}

	_changePosition(model,value){
		this.props.change(model,value ? _.toNumber(value):undefined);
	}

	_addOption(){
		this.props.add(`surveys.edit.question.options`,{option_number: this.refs.option_number.value, option_text: this.refs.option_text.value});
		this.refs.option_number.value='';
		this.refs.option_text.value='';
	}

	_removeOption(index) {
		this.props.remove(`surveys.edit.question.options`,index);
	}

	_addQuestion(){
		let { typeQuestion, question } = this.state;

		if(typeQuestion && question){
			this.props.add('surveys.edit.question.children_questions',{
				name: question,
				type: typeQuestion,
				options: []
			})
			this.setState({
				question: '',
				typeQuestion: ''
			})
		}
	}

	_validAddQuestion(){
		let { typeQuestion, question } = this.state;
		let response = true;

		if(typeQuestion && question){
			response = false;
		}

		return response;
	}

	_removeQuestion(index){
		this.props.remove(`surveys.edit.question.children_questions`,index);
	}

	_getType(type){
		switch (type){
			case 'group':
				return 'Grupo'
			case 'number':
				return 'Número'
			case 'sum':
				return 'Suma'
			case 'average':
				return 'Promedio'
			case 'percentage':
				return 'Porcentaje'
			case 'interval':
				return 'Intervalo'
			case 'rating':
				return 'Calificación (1 al 5)'
			case 'input':
				return 'Texto Simple'
			case 'text':
				return 'Área de Texto'
			case 'boolean':
				return 'Verdadero/Falso'
			case 'multiple':
				return 'Opción multiple'
			default:
				return '';
		}
	}
}


export default SurveysEditForm;


// WEBPACK FOOTER //
// ./src/elements/surveys/form.jsx